// removed by extract-text-webpack-plugin
module.exports = {"infoText":"infoText__3mIQH","loaderContainer":"loaderContainer__3AsjL","redirectWrapper":"redirectWrapper__3Y6Z0","bottomLink":"bottomLink__1r-yr","loader":"loader__BC3s3"};


//////////////////
// WEBPACK FOOTER
// ./components/blockResult/style.css
// module id = YGqN
// module chunks = 308 314 342 343 351 364 365 388